import { EVALUATOR_PLAYGROUND_BATCH_SIZE } from '../constants';

export const mergeExampleRuns = <T extends { id: string }>(
  fetchedExampleRuns: T[],
  constructedExampleRuns: T[]
): T[] => {
  const numFetchedExampleRuns = fetchedExampleRuns?.length ?? 0;
  const numRunsToAdd = EVALUATOR_PLAYGROUND_BATCH_SIZE - numFetchedExampleRuns;

  const fetchedRunIds = new Set(fetchedExampleRuns.map((fr) => fr.id));
  const runsToAdd = constructedExampleRuns
    .filter((r) => !fetchedRunIds.has(r.id))
    .slice(0, numRunsToAdd);
  return [...fetchedExampleRuns, ...runsToAdd];
};
